<template>
  <div class="search" :style="{transform:`translateY(${openSearch?0:'100%'})`}">
    <div class="search-header">
      <div style="padding-right:10px;" class="flex-center">
        <span>{{searchCity}}</span>
      </div>
      <div style="flex: 1;">
        <van-field ref="search" left-icon="search" clearable v-model="searchValue" placeholder="请输入地址搜索" @input="handleQuery" @clear="handleQuery" />
      </div>
      <div style="padding-left:10px;" @click="cancelSearch">{{form.province?'取消':'返回'}}</div>
    </div>
    <div class="search-list">
      <div class="flex-sa" style="font-size: 13px;color: #5C5C5C;padding-bottom: 10px;border-bottom:1px solid #F5F5F5">
        <div style="padding-bottom: 15px 0;" class="flex-center" @click="handleOpenSearch(false)">
          <span>地图选址</span>
        </div>
        <div style="padding-bottom: 15px 0;" @click="handleShowIdentification">
          <span>地址识别</span>
        </div>
      </div>
      <div class="search-main">
        <div class="search-item" v-for='(item,index) in list' :key="index" @click="searchItemClick(item)">
          <van-icon name="location" color="#F1892E" size="20px" class="location-icon" />
          <div class="search-item-content">
            <div class="--title">{{item.title}}</div>
            <div class="--address">{{item.address}}</div>
          </div>
          <div class="prompt" v-if="item.prompt">{{item.prompt}}</div>
        </div>
        <van-empty
          image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
          description="暂无数据"
          image-size="50px"
          v-show="list&&!list.length&&!listLoading"
        />
        <van-loading color="rgba(0,0,0,.5)" size="40px" v-show="listLoading" class="loading" />
      </div>
    </div>
  </div>
</template>

<script>
import { Field , Toast , Icon , Empty , Loading } from 'vant';
import { mapSuggestion , geocoder } from '@/api/dispatch/components/search-list.js';
export default {
  name:'dispatch-search-list',
  props:['map','openSearch','mapCenterInfo','showIdentification','locationPhoneInfo'],
  components:{ 
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
   },
  data(){
    return {
      searchList:[],
      form:{},
      searchValue:'',
      // searchCity:'',  //搜索方位(城市)  例如:深圳
      listLoading:false,
      list:[],
      searchItemActive:{},  //当前点击的搜索项
      mapPanendDisabled:true,  //控制平移结束方法是否执行
      queryTimer:null,  //防抖定时器
    }
  },
  computed:{
    searchCity(){
      return this.mapCenterInfo.city?this.mapCenterInfo.city:''
    }
  },
  watch:{
    openSearch(nVal,oVal){
      if(nVal&&nVal!=oVal) {
        this.searchValue = '';
        this.setLocationPhoneInfo()
        .then(locationPhone=>this.list = [locationPhone])
        .catch(()=>this.list = [])
      }
    }
  },
  methods:{
    mountPanend(map){
      map.on('panend',this.mapPanend);
    },
    handleQuery(){
      if(this.queryTimer) {
        clearTimeout(this.queryTimer);
        this.queryTimer = null;
      }
      this.queryTimer = setTimeout(() => {
        this.getList();
      }, 200);
    },
    /** 获取搜索列表 */
    async getList(){
      if(!this.searchValue) {
        this.setLocationPhoneInfo()
        .then(locationPhone=>this.list = [locationPhone])
        .catch(()=>this.list = [])
      }
      try {
        this.list = [];
        this.listLoading = true;
        let { centerCity } = await this.getMapCenter({notSetInfo:true});
        let { data } = await mapSuggestion({keyword:this.searchValue,region:centerCity,policy:1});
        this.setLocationPhoneInfo()
        .then(locationPhone=>{
          data.unshift(locationPhone);
          this.list = data;
          this.listLoading = false;
        })
        .catch(()=>{
          this.list = data;
          this.listLoading = false;
        })
        
      } catch (error) {
        this.listLoading = false;
      }
    },
    setLocationPhoneInfo(){
      if(['province','city','detailedAddress','title','latitude','longitude'].every(key=>this.locationPhoneInfo[key])){
        return Promise.resolve({
          address:this.locationPhoneInfo.detailedAddress,
          city:this.locationPhoneInfo.city,
          district:this.locationPhoneInfo.district,
          location:{
            lat:this.locationPhoneInfo.latitude,
            lng:this.locationPhoneInfo.longitude
          },
          province:this.locationPhoneInfo.province,
          title:this.locationPhoneInfo.title,
          prompt:'当前位置',
        })
      }else return Promise.reject();
    },
    async getMapCenter(){
      try {
        let { lat , lng } = this.map.getCenter();
        let { result } = await geocoder({location:`${lat},${lng}`,get_poi:1,poi_options:'policy=2'});
        if(!result.pois||!result.pois.length) return Promise.reject({centerCity:''});
        else return Promise.resolve({centerCity:result.address_component.city});
      } catch (error) {
        return Promise.reject(error);
      }
  },
    /** 打开搜索框 */
    handleOpenSearch(boolean){
      this.$emit('update:openSearch',boolean)
    },
    /** 地图平移结束 */
    mapPanend(){
      if(this.mapPanendDisabled) return;
      this.$emit('update:mapCenterInfo',{
        province:this.searchItemActive.province,  //省
        city:this.searchItemActive.city,  //市
        district:this.searchItemActive.district,  //区
        detailedAddress:this.searchItemActive.address,  //详细地址
        title:this.searchItemActive.title,  //标题
        latitude:this.searchItemActive.location.lat,
        longitude:this.searchItemActive.location.lng,
        adcode: this.searchItemActive.adcode
      })
      this.$emit('update:getCenterLoading',false);
      this.mapPanendDisabled = true;
    },
    // 搜索项的点击
    searchItemClick(item) {
      this.searchItemActive = item
      this.mapPanendDisabled = false;
      this.map.panTo(new window.TMap.LatLng(item.location.lat, item.location.lng));
      this.$emit('update:getCenterLoading',true);
      this.handleOpenSearch(false);
    },
    // 地址识别方法
    handleShowIdentification() {
      this.handleOpenSearch(false);
      this.$emit('update:showIdentification',true);
    },
    cancelSearch(){
      this.handleOpenSearch(false);
      // else uni.navigateBack({ delete: 1 });
    }
  }
}
</script>

<style scoped lang="scss">
 .search {
    position: fixed !important;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    // display: none;
    flex-direction: column;
    transition: all 0.3s;
    display: flex;
  }

  .search-header {
    padding: 15px 22px;
    padding-bottom: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #FFF;
    .van-search {
      padding: 0;
    }
  }
.search-list {
  flex: 1;
  margin: 10px 7px 0 7px;
  padding: 15px;
  padding-bottom: 0;
  border-radius: 10px;
  background: #FFF;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.search-main {
  flex: 1;
  overflow-y: auto;
}

.search-item {
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #F5F5F5;
  .prompt {
    font-size: 13px;
    color: #A4A4A4;
    margin-left: 15px;
  }
  .location-icon {
    flex-shrink: 0;
    margin-right: 10px;
  }
  &-content {
    flex: 1;
    .--title {
      font-size: 16px;
      color: #130A01;
      font-weight: bold;
    }
    .--address {
      font-size: 13px;
      color: #A4A4A4;
    }
  }
}
  .loading {
    width: 100%;
    margin-top: 32px;
    text-align: center;
  }
</style>